import { render, staticRenderFns } from "./autobackup.vue?vue&type=template&id=5b12110e&"
import script from "./autobackup.vue?vue&type=script&lang=js&"
export * from "./autobackup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports